import { Accordion } from '@gleamer/ui';
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import classnames from 'classnames';
import React, { useState } from 'react';
import { usePredictions } from '../../../contexts/PredictionsContext';
import { useCurrentDetectionId } from '../../../contexts/predictions.hooks';
import { Detection, Prediction } from '../../../types/prediction.type';

type SeriesPredictionEntriesProps = {
  prediction: Prediction;
  detection: Detection;
  index: number;
};

export function SeriesPredictionEntry({
  prediction,
  detection,
  index,
}: SeriesPredictionEntriesProps) {
  const [isHover, setIsHover] = useState(false);

  const [currentAnnotationId] = useCurrentDetectionId();
  const { onDetectionSelection, onDetectionHover } = usePredictions();

  const onMouseEnter = () => {
    setIsHover(true);
    onDetectionHover(detection.annotationId, true);
  };

  const onMouseLeave = () => {
    setIsHover(false);
    onDetectionHover(detection.annotationId, false);
  };

  return (
    <Accordion>
      <div
        className={classnames(
          'flex items-center justify-start bg-primary-dark py-1 text-primary-light group-hover:bg-secondary-main',
          {
            'bg-secondary-main':
              detection.annotationId &&
              detection.annotationId === currentAnnotationId,
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Accordion.Title inactive>
          <h6 className="text-sm font-medium leading-snug">
            {detection.type} - {detection.confidence.toFixed(1)}
          </h6>
        </Accordion.Title>
        <button
          title={`Focus detection ${
            detection.type
          } - ${detection.confidence.toFixed(1)}`}
          className={classnames(
            'ml-2 w-4 cursor-pointer text-white transition duration-300',
            isHover ? 'opacity-1 visible mr-1' : 'invisible mr-2 opacity-0'
          )}
          onClick={() => onDetectionSelection(prediction, detection)}
        >
          <MagnifyingGlassIcon />
        </button>
      </div>
    </Accordion>
  );
}
